import React from 'react';
import PropTypes from 'prop-types';

import AreaFilter from './area-filter';
import ComparisonFilter from './comparison-filter';
import DateRangeFilter from './date-range-filter';
import DaytimeFilter from './daytime-filter';
import QuickDateFilter from './quick-date-filter';
import SessionLengthFilter from './session-length-filter';
import WeekdayFilter from './weekday-filter';

const Filters = {
  AreaFilter,
  ComparisonFilter,
  DateRangeFilter,
  DaytimeFilter,
  QuickDateFilter,
  SessionLengthFilter,
  WeekdayFilter,
};

const FilterSelector = (props) => {
  const { filterName } = props;
  const MatchingFilter = Filters[filterName];

  if (!MatchingFilter) {
    if (filterName !== 'MultiLocationFilter') {
      console.error(`${filterName} is not a valid filter`);
    }
    return null;
  }

  return <MatchingFilter {...props} />;
};

FilterSelector.propTypes = {
  filterName: PropTypes.string.isRequired,
};

export default FilterSelector;
